import OCGatewayClient from "../client/OCGatewayClient";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export type UserExperienceRatingActionTaken =
    | "dismissed"
    | "google_review"
    | "trustpilot_review"
    | "contact_support";

export type UserExperienceRatingPrompt = {
    id: number;
    userId: number;
    rating: number | null;
    actionTaken: UserExperienceRatingActionTaken | null;
    promptedAt: string | Date;
    actionedAt: string | Date | null;
    createdAt: string | Date;
    updatedAt: string | Date;
};

export type GetUserExperienceRatingPromptResponse = {
    shouldPrompt: boolean;
    prompt: UserExperienceRatingPrompt | null;
    reason?: "active_prompt" | "created" | "recent_action" | "account_too_new";
};

export type SetUserExperienceRatingPromptResultRequest = {
    promptId?: number;
    rating?: number | null;
    actionTaken?: UserExperienceRatingActionTaken | null;
};

export type SetUserExperienceRatingPromptResultResponse = {
    success: true;
    prompt: UserExperienceRatingPrompt;
};

export function useUserExperienceRatingPromptQuery() {
    return useQuery({
        queryKey: ["getUserExperienceRatingPrompt"],
        queryFn: async () => {
            return OCGatewayClient.request(
                "getUserExperienceRatingPrompt",
                {}
            ) as Promise<GetUserExperienceRatingPromptResponse>;
        },
        staleTime: 1000 * 60 * 5,
        gcTime: 1000 * 60 * 60 * 24,
        networkMode: "always",
        retry: false
    });
}

export function useSetUserExperienceRatingPromptResultMutation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ["setUserExperienceRatingPromptResult"],
        mutationFn: async (payload: SetUserExperienceRatingPromptResultRequest) => {
            return OCGatewayClient.request(
                "setUserExperienceRatingPromptResult",
                payload
            ) as Promise<SetUserExperienceRatingPromptResultResponse>;
        },
        onSettled: () => {
            queryClient.invalidateQueries({
                queryKey: ["getUserExperienceRatingPrompt"]
            });
        }
    });
}
